import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import AddSharpIcon from "@material-ui/icons/AddSharp";
import RemoveIcon from "@material-ui/icons/Remove";
import "../../styles/faq.scss";
import "../../styles/tablerealestatefaq.scss";
import Traditionalprocessfaq from "../pages/Faq/Traditionalprocessfaq";
import Howitworksrealestatefaq from "../pages/Faq/Howitworksrealestatefaq";
import Myclientfaq from "../pages/Faq/Myclientfaq";
import Helpmerealestatefaq from "../pages/Faq/Helpmerealestatefaq";
import { useGAEventsTracker } from "../../util/gtag";
import NewHowItWorkFaq from "./NewHowItWorkFaq";

const Accordion = withStyles({
  root: {
    borderTop: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:first-child)": {
      borderTop: "1px solid rgba(0, 0, 0, .125)",
    },
    "&:before": {
      display: "none",
    },
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(0, 0, 0, .125)",
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderBottom: "0px solid #000",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function NewFaq(props) {
  const GAEventTrackerHomeBuyer = useGAEventsTracker(
    window.location.pathname,
    "/Home Buyer"
  );
  const GAEventTrackerRealEstate = useGAEventsTracker(
    window.location.pathname,
    "/Real Estate Agent"
  );
  const GAEventTrackerHomeBuyerQue1 = useGAEventsTracker(
    window.location.pathname + "/Homebuyer/What is The Trade-In Mortgage™"
  );
  const GAEventTrackerHomeBuyerQue2 = useGAEventsTracker(
    window.location.pathname + "/Homebuyer/How does it work"
  );
  const GAEventTrackerHomeBuyerQue3 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/How much does The Trade-In Mortgage™ cost"
  );
  const GAEventTrackerHomeBuyerQue4 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/How do I get started and apply for The Trade-In Mortgage™"
  );
  const GAEventTrackerHomeBuyerQue5 = useGAEventsTracker(
    window.location.pathname + "/Homebuyer/Can I use my own real estate agent"
  );
  const GAEventTrackerHomeBuyerQue6 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/Do I have to make two mortgage payments"
  );
  const GAEventTrackerHomeBuyerQue7 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/How does The Trade-In Mortgage™ compare to the traditional process"
  );
  const GAEventTrackerHomeBuyerQue8 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/How does The Trade-In Mortgage™ pricing compare to iBuyers or other buy-first solutions"
  );
  const GAEventTrackerHomeBuyerQue9 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/What happens if my original house doesn’t sell within the specified timeframe on the open market"
  );
  const GAEventTrackerHomeBuyerQue10 = useGAEventsTracker(
    window.location.pathname +
      "/Homebuyer/Are there any limits to the type of property I can try with The Trade-In Mortgage™"
  );
  const GAEventTrackerRealEstateAgentQue1 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/What is The Trade-In Mortgage™"
  );
  const GAEventTrackerRealEstateAgentQue2 = useGAEventsTracker(
    window.location.pathname + "/Are You A RealEstateAgent/How does it work"
  );
  const GAEventTrackerRealEstateAgentQue3 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/How will it help my clients"
  );
  const GAEventTrackerRealEstateAgentQue4 = useGAEventsTracker(
    window.location.pathname + "/Are You A RealEstateAgent/How will it help me™"
  );
  const GAEventTrackerRealEstateAgentQue5 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/How much will The Trade-In Mortgage™ cost me as an agent"
  );
  const GAEventTrackerRealEstateAgentQue6 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/How much more will The Trade-In Mortgage™ cost my clients compared to a traditional mortgage"
  );
  const GAEventTrackerRealEstateAgentQue7 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/How do I get started with The Trade-In Mortgage™ program"
  );
  const GAEventTrackerRealEstateAgentQue8 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/How does my client request The Trade-In Mortgage™"
  );
  const GAEventTrackerRealEstateAgentQue9 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/What do I need to do differently as an agent if my client uses The Trade-In Mortgage™"
  );
  const GAEventTrackerRealEstateAgentQue10 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/How does The Trade-In Mortgage™ compare to other buy-first solutions"
  );
  const GAEventTrackerRealEstateAgentQue11 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/Do I need to worry about RESPA or any other compliance issues"
  );
  const GAEventTrackerRealEstateAgentQue12 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/What happens if my client’s original home doesn’t sell within the specified timeframe"
  );
  const GAEventTrackerRealEstateAgentQue13 = useGAEventsTracker(
    window.location.pathname +
      "/Are You A RealEstateAgent/Are there any limits to the type of property my client can buy with The Trade-In Mortgage™"
  );
  const [expanded, setExpanded] = React.useState("panel1");
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState();
  const [open3, setOpen3] = React.useState();
  const [open4, setOpen4] = React.useState();
  const [open5, setOpen5] = React.useState();
  const [open6, setOpen6] = React.useState(false);
  const [open7, setOpen7] = React.useState();
  const [open8, setOpen8] = React.useState(false);
  const [open9, setOpen9] = React.useState();
  const [open10, setOpen10] = React.useState();
  // <----------------------------Realestate-faq----------------------------->
  const [open11, setOpen11] = React.useState(false);
  const [open12, setOpen12] = React.useState();
  const [open13, setOpen13] = React.useState();
  const [open14, setOpen14] = React.useState();
  const [open15, setOpen15] = React.useState();
  const [open16, setOpen16] = React.useState();
  const [open17, setOpen17] = React.useState();
  const [open18, setOpen18] = React.useState();
  const [open19, setOpen19] = React.useState();
  const [open20, setOpen20] = React.useState();
  const [open21, setOpen21] = React.useState();
  const [open22, setOpen22] = React.useState();
  const [open23, setOpen23] = React.useState();
  const [open24, setOpen24] = React.useState();
  const [showResults, setShowResults] = React.useState(true);
  const [showResultsTwo, setShowResultsTwo] = React.useState(false);

  useEffect(() => {
    if (props?.partner?.url_path === "c2") {
      const liTags = document.querySelectorAll("li");
      const spanTags = document.querySelectorAll("span");
      liTags.forEach((li) => {
        li.classList.add("ftpolar-light");
      });
      spanTags.forEach((span) => {
        span.classList.add("ftpolar-light");
      });
    }
  }, [props?.partner?.url_path, showResults, showResultsTwo]);

  const onClick = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
    GAEventTrackerHomeBuyer("Homebuyer", 1);
    setShowResults(true);
    setShowResultsTwo(false);
  };
  const onClickChange = () => {
    setOpen11(false);
    setOpen12(false);
    setOpen13(false);
    setOpen14(false);
    setOpen15(false);
    setOpen16(false);
    setOpen17(false);
    setOpen18(false);
    setOpen19(false);
    setOpen20(false);
    setOpen21(false);
    setOpen22(false);
    setOpen23(false);
    setOpen24(false);
    props.setEfficient(false);
    GAEventTrackerRealEstate("Real Estate Agent", 1);
    setShowResults(false);
    setShowResultsTwo(true);
  };
  const handleOpenFaq = () => {
    setOpen4(!open4);
    return window.scrollTo(0, 0);
  };
  const handleLink = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="inter">
      <div className="top-padding-medium bottom-padding-medium">
        <div className="d-flex justify-content-between">
          <div id="faq">
            <h2
              className="new-jost-bold new-main-heading"
              style={{ fontSize: "32px" }}
            >
              FAQs
            </h2>
          </div>
        </div>
        {showResults === true && (
          <div>
            <Accordion style={{ borderTop: "none" }}>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue1("FAQs/Questionnaire", 1);
                  setOpen1(!open1);
                }}
                expandIcon={open1 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  How does Calque work?
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  Calque provides borrowers with a binding backup offer on their
                  existing home, allowing loan officers to exclude the departing
                  residence and any second lien needed from debt-to-income. This
                  enables borrowers to make offers with no home sale
                  contingency, move into their new home first, and sell their
                  previous one with the confidence of a guaranteed backup buyer.
                </span>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue3("FAQs/Questionnaire", 1);
                  setOpen3(!open3);
                }}
                expandIcon={open3 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  What's the difference between{" "}
                  {props?.partner?.partner_program_name} and the Contingency
                  Buster?
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  Both {props?.partner?.partner_program_name} and
                  Contingency Buster give homeowners a seamless, confident way
                  to buy their next home before selling their current one.
                  <br />
                  <br />
                  The Contingency Buster is typically faster and may result in
                  lower fees because, in most cases, its Purchase Price
                  Guarantee (PPG) only covers the minimum amount required to
                  remove the home sale contingency. In comparison,{" "}
                  {props?.partner?.partner_program_name} typically has higher
                  PPGs—designed to cover both the remaining mortgage balance and
                  a second lien for equity unlock. However, this option may take
                  a few additional days to process.
                  <br />
                  <br />
                  Remember, our program fee is the same for both products: 1% of
                  the Purchase Price Guarantee (PPG) + $2,000 administration
                  fee.
                  <br />
                  <br />
                  In both cases, the final PPG amount is subject to Calque’s
                  review process and varies based on multiple factors.
                  <br />
                  <br />
                  For full details, check out:{" "}
                  <a
                    href="https://calqueinc.com/calque-academy/"
                    style={{ textDecoration: "underline" }}
                  >
                    Calque Academy
                  </a>
                  .
                </span>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={open4 === true ? true : false}>
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue4("FAQs/Questionnaire", 1);
                  setOpen4(!open4);
                }}
                expandIcon={open4 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  What is the Purchase Price Guarantee (PPG)?
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  Calque’s Purchase Price Guarantee (PPG) enables loan officers
                  to provide buy-before-you-sell programs. With a Calque PPG,
                  financing for the new home is approved without a home sale
                  contingency and debt-to-income constraints are removed in the
                  scenarios below.
                  <br />
                  DTI Relief: If the homeowner has the necessary down payment
                  but cannot carry two mortgages, the PPG offer removes their
                  current mortgage from the Debt-to-Income (DTI) calculation,
                  allowing loan officers to approve financing for their new
                  home.
                  <br />
                  <br />
                  Equity Access: If the homeowner needs to tap into their home
                  equity for a down payment, debt payoff, or other expenses, the
                  PPG offer enables access through a second lien (bridge, HELOC,
                  HELOAN, etc)—again, without factoring those payments into DTI.
                  Calque is not a lender and does not provide funding. If
                  borrowers need to access their home’s equity, their loan
                  officer will arrange a second lien, with any associated fees
                  handled by the originating lender.
                  <br />
                  <br />
                  In both cases, the PPG offer makes it easier for homeowners to
                  buy before they sell with confidence.
                </span>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue5("FAQs/Questionnaire", 1);
                  setOpen5(!open5);
                }}
                expandIcon={open5 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  What types of properties qualify/disqualify for the programs?
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  There are some exclusions to our programs, which are outlined
                  in our{" "}
                  <a
                    href="https://calqueinc.com/ppg-guidelines/"
                    style={{ textDecoration: "underline" }}
                  >
                    PPG guidelines
                  </a>
                  .<br />
                  <br />
                  If you have specific questions not addressed in our
                  guidelines, please feel free to reach out.{" "}
                </span>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue6("FAQs/Questionnaire", 1);
                  setOpen6(!open6);
                }}
                expandIcon={open6 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  Is Calque a Lender?
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  No, Calque is not a lender and does not provide any funding.
                  If a borrower needs to access the equity in their existing
                  home, the loan officer would originate or broker a second lien
                  (bridge, HELOC, or HELOAN, etc) to access that equity. Any
                  fees associated with the second lien would be processed
                  through the originating lender.
                </span>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue7("FAQs/Questionnaire", 1);
                  setOpen7(!open7);
                }}
                expandIcon={open7 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  How much does it cost to use Calque's program?
                </span>
              </AccordionSummary>
              <AccordionDetails style={{ marginLeft: "10px" }}>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  Calque's fees are collected during the settlement of the
                  departing residence as part of the closing costs.
                </span>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => {
                  GAEventTrackerHomeBuyerQue9("FAQs/Questionnaire", 1);
                  setOpen9(!open9);
                }}
                expandIcon={open9 ? <RemoveIcon /> : <AddSharpIcon />}
                style={{
                  flexDirection: "row-reverse",
                  padding: "10px 0px 0px 0px",
                }}
              >
                <span
                  className="jost-medium table-sub-heading"
                  style={{ fontWeight: 400, color: "#000" }}
                >
                  Are there any hidden fees?
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <span
                  className="table-details"
                  style={{ textAlign: "justify" }}
                >
                  We do not have any additional or hidden fees. We only charge a
                  $2,000 administrative fee, plus 1% of our PPG offer.
                </span>
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </div>
    </div>
  );
}
